/** Versiunea locală a frontend-ului (injectată la build din package.json). */
export const APP_VERSION: string =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '0.1.0';
